var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('gl-card',{staticClass:"gl-rounded-lg gl-bg-section",attrs:{"header-class":"gl-rounded-lg gl-px-0 gl-py-0 gl-bg-section gl-border-b-0","body-class":"gl-pt-2 gl-pb-0 gl-px-2"},scopedSlots:_vm._u([{key:"header",fn:function(){return [_vm._t("stages")]},proxy:true}],null,true)},[_vm._v(" "),_vm._t("jobs")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }